(function faqSearch() {
  document.querySelectorAll('.feel-pdp-faq').forEach(function (root) {
    if (root.dataset.faqInit) return;
    root.dataset.faqInit = '1';

    var input = root.querySelector('[data-faq-search]');
    var list = root.querySelector('[data-faq-list]');
    var empty = root.querySelector('[data-faq-empty]');
    if (!input || !list) return;

    var items = list.querySelectorAll('.faq-v2-item');

    function normalise(s) { return (s || '').toLowerCase().trim(); }

    var debounce;
    input.addEventListener('input', function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        var q = normalise(input.value);
        var shown = 0;
        items.forEach(function (item) {
          if (!q) {
            item.classList.remove('faq-v2-hidden');
            shown++;
            return;
          }
          var keys = normalise(item.getAttribute('data-faq-keys'));
          var summary = normalise(item.querySelector('summary') ? item.querySelector('summary').textContent : '');
          var body = normalise(item.querySelector('.faq-v2-body') ? item.querySelector('.faq-v2-body').textContent : '');
          if (keys.indexOf(q) >= 0 || summary.indexOf(q) >= 0 || body.indexOf(q) >= 0) {
            item.classList.remove('faq-v2-hidden');
            shown++;
          } else {
            item.classList.add('faq-v2-hidden');
          }
        });
        if (empty) {
          if (shown === 0) empty.removeAttribute('hidden');
          else empty.setAttribute('hidden', '');
        }
      }, 150);
    });
  });
})();
